/**
 * Routes fragments
 */
export const BaseRoutePath = '';

// Generic
export const NotFoundRoutePath = 'not-found';
export const ForbiddenRoutePath = 'forbidden';
export const SoonAvailableRoutePath = 'soon-available';

// Authentication
export const AuthenticationRoutePath = 'authentication';
export const LoginRoutePath = 'login';
export const RegisterRoutePath = 'register';
export const CallbackRoutePath = 'callback';
export const LogoutRoutePath = 'logout';

// Anonymous
export const AnonymousRoutePath = 'anonymous';

// Authenticated
export const AuthenticatedRoutePath = 'authenticated';

// Home
export const HomeRoutePath = 'home';

// Common Settings
export const CommonSettingsRoutePath = 'common-settings';
export const NaturesAffairesRoutePath = 'natures-affaires';
export const BarreauxRoutePath = 'barreaux';
export const CarpaRoutePath = 'carpa';
export const CarpaDelegationRoutePath = 'carpa-delegation';
export const QualitesTiersRoutePath = 'qualites-tiers';
export const NaturesTypesOperationsRoutePath = 'natures-types-operations';
export const PaysRoutePath = 'pays';
export const DevisesRoutePath = 'devises';
export const ModesReceptionRoutePath = 'modes-reception';
export const CodesInterbancairesRoutePath = 'codes-interbancaires';
export const LiassesChequesRoutePath = 'Liasses-cheques';
export const UtilisateursRoutePath = 'utilisateurs';
export const ModelesDocumentsRoutePath = 'modeles-courriers';
export const LibellesAControlerRoutePath = 'libelle-a-controller';
export const DroitsProfilsRoutePath = 'droits-profils';
export const ParametresRoutePath = 'parametres';
export const ParametresCarpaRoutePath = 'parametres-carpa';
export const TypeFacteurRisqueRoutePath = 'typeFacteurRisque';
export const StatistiquesRoutePath = 'statistiques';
export const StatistiquesFichiersRoutePath = 'fichiers';
export const TableauBordPresidentRoutePath = 'Tableau-bord-president';
export const BanquesRoutePath = 'banques';
export const IbanFrauduleuxPageRoutePath = 'ibanFrauduleux';
export const MessagesRoutePath = 'messages';
export const VersionRoutePath = 'version';

// Recherche Consultation
export const RechercheConsultationRoutePath = 'recherche-consultation';
export const RechercheAffaireRoutePath = 'recherche-affaire';
export const ConsultAffaireRoutePath = 'affaire/:id';
export const ConsultCompteRoutePath = 'compte/:id';
export const SuiviCommentairesRoutePath = 'suivi-commentaires';
// Labft
export const BenefEffectifRoutePath = 'registre-benef-effectif';
// Gestion des avocats
export const GestionAvocatsRoutePath = 'gestion-avocats';
export const OuvrirCompteRoutePath = 'ouvrir-compte';
export const GererEvenementsRoutePath = 'gerer-evenements';

// Saisie
export const SaisieRoutePath = 'saisies';
export const SaisieOperationsRoutePath = 'saisie-operations';
export const SaisieOperationsByBordereauIdRoutePath = 'saisie-operations/:type/:id';
export const SaisieTraitementOperationsEcarpaRoutePath = 'traitement-operations';
export const OperationsEnregistreesRoutePath = 'operations-enregistrees';
export const VirementsRecusRoutePath = 'virements-recus';
export const FondsIndisponiblesRoutePath = 'fonds-indisponibles';

// Validation
export const ValidationRoutePath = 'validation';

// Rapprochement Bancaire
export const RapprochementBancairePath = 'rapprochement-bancaire';
export const RapprochementBancairePagePath = 'page';
export const RapprochementJobIntegrationBancairePagePath = 'job-integration-bancaire';

// Generation
export const GenerationPath = 'generation';
export const GenerationConsultationPath = 'generation-consultation';
export const LotVirtuelPath = 'operations-reprise';

// Administration
export const AdminRoutePath = 'admin';
export const AdminLogRoutePath = 'log';
export const AdminFileRoutePath = 'file';
export const AdminHealthCheckRoutePath = 'health-checks';
export const MaintenancePageRoutePath = 'maintenance';

/**
 * Routes full paths
 */
export function getBasePath(): string {
	return BaseRoutePath;
}

// Generic pages
export function getNotFoundFullPath(): string {
	return `${getBasePath()}/${NotFoundRoutePath}`;
}

export function getForbiddenFullPath(): string {
	return `${getBasePath()}/${ForbiddenRoutePath}`;
}

// Authentication pages
export function getAuthenticationFullPath(): string {
	return `${getBasePath()}/${AuthenticationRoutePath}`;
}

export function getLoginFullPath(): string {
	return `${getAuthenticationFullPath()}/${LoginRoutePath}`;
}

export function getRegisterFullPath(): string {
	return `${getAuthenticationFullPath()}/${RegisterRoutePath}`;
}

export function getLoginCallbackFullPath(): string {
	return `${getAuthenticationFullPath()}/${CallbackRoutePath}`;
}

export function getLogoutFullPath(): string {
	return `${getAuthenticationFullPath()}/${LogoutRoutePath}`;
}

// Authenticated pages
export function getAuthenticatedFullPath(): string {
	return `${getBasePath()}/${AuthenticatedRoutePath}`;
}

// Home
export function getHomeFullPath(): string {
	return `${getAuthenticatedFullPath()}/${HomeRoutePath}`;
}

// Common Settings
export function getCommonSettingsFullPath(): string {
	return `${getAuthenticatedFullPath()}/${CommonSettingsRoutePath}`;
}

export function getCommonSettingsNaturesAffairesRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${NaturesAffairesRoutePath}`;
}

export function getCommonSettingsBarreauxRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${BarreauxRoutePath}`;
}

export function getCommonSettingsCarpaRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${CarpaRoutePath}`;
}

export function getCommonSettingsCarpaDelegationRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${CarpaDelegationRoutePath}`;
}

export function getCommonSettingsQualitesTiersRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${QualitesTiersRoutePath}`;
}

export function getCommonSettingsPaysRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${PaysRoutePath}`;
}

export function getCommonSettingsDevisesRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${DevisesRoutePath}`;
}

export function getCommonSettingsNaturesTypesOperationsRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${NaturesTypesOperationsRoutePath}`;
}

export function getCommonSettingUtilisateursRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${UtilisateursRoutePath}`;
}

export function getCommonSettingBanquesRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${BanquesRoutePath}`;
}

export function getCommonSettingsModesReceptionRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${ModesReceptionRoutePath}`;
}

export function getCommonSettingsCodesInterbancairesRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${CodesInterbancairesRoutePath}`;
}

export function getCommonSettingsModeleDocumentsRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${ModelesDocumentsRoutePath}`;
}

export function getCommonSettingsLibelleAControlerRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${LibellesAControlerRoutePath}`;
}

export function getCommonSettingsDroitsProfilsRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${DroitsProfilsRoutePath}`;
}

export function getCommonSettingsParametersRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${ParametresRoutePath}`;
}

export function getCommonSettingsTypeFacteurRisqueRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${TypeFacteurRisqueRoutePath}`;
}

export function getCommonSettingsParametersCarpaRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${ParametresCarpaRoutePath}`;
}

export function getCommonSettingsIbanFrauduleuxPageRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${IbanFrauduleuxPageRoutePath}`;
}

export function getCommonSettingsMessagesRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${MessagesRoutePath}`;
}

// version
export function getVersionRoutePath(): string {
	return `${getAuthenticatedFullPath()}/${VersionRoutePath}`;
}

// Statistiques
export function getStatistiquesRoutePath(): string {
	return `${getAuthenticatedFullPath()}/${StatistiquesRoutePath}`;
}

export function getStatistiquesFichiersRoutePath(): string {
	return `${getAuthenticatedFullPath()}/${StatistiquesRoutePath}/${StatistiquesFichiersRoutePath}`;
}

export function getTableauBordPresidentRoutePath(): string {
	return `${getAuthenticatedFullPath()}/${StatistiquesRoutePath}/${TableauBordPresidentRoutePath}`;
}

// Gestion des avocats
export function getGestionAvocatsFullPath(): string {
	return `${getAuthenticatedFullPath()}/${GestionAvocatsRoutePath}`;
}
export function getOuvrirCompteRoutePath(): string {
	return `${getGestionAvocatsFullPath()}/${OuvrirCompteRoutePath}`;
}
export function getGererEvenementsRoutePath(): string {
	return `${getGestionAvocatsFullPath()}/${GererEvenementsRoutePath}`;
}

// Recherche Consultation
export function getRechercheConsultationFullPath(): string {
	return `${getAuthenticatedFullPath()}/${RechercheConsultationRoutePath}`;
}
export function getRegistreBenefEffectifFullPath(): string {
	return `${getRechercheConsultationFullPath()}/${BenefEffectifRoutePath}`;
}

export function getSuiviCommentairesFullPath(): string {
	return `${getRechercheConsultationFullPath()}/${SuiviCommentairesRoutePath}`;
}

export function getRechercheAffaireRoutePath(): string {
	return `${getRechercheConsultationFullPath()}/${RechercheAffaireRoutePath}`;
}

export function getConsultAffaireRoutePath(id: string): string {
	return `${getRechercheConsultationFullPath()}/${ConsultAffaireRoutePath.replace(':id', '' + id)}`;
}

export function getConsultCompteRoutePath(id: string): string {
	return `${getRechercheConsultationFullPath()}/${ConsultCompteRoutePath.replace(':id', '' + id)}`;
}

// Saisie
export function getSaisiesFullPath(): string {
	return `${getAuthenticatedFullPath()}/${SaisieRoutePath}`;
}

export function getSaisieOperationsRoutePath(): string {
	return `${getSaisiesFullPath()}/${SaisieOperationsRoutePath}`;
}

export function getSaisieOperationsByIdRoutePath(type: string, id: string): string {
	return `${getSaisiesFullPath()}/${SaisieOperationsByBordereauIdRoutePath.replace(':type', '' + type).replace(':id', '' + id)}`;
}

export function getSaisieTraitementOperationsECarpaRoutePath(): string {
	return `${getSaisiesFullPath()}/${SaisieTraitementOperationsEcarpaRoutePath}`;
}

export function getOperationsEnregistreesRoutePath(): string {
	return `${getSaisiesFullPath()}/${OperationsEnregistreesRoutePath}`;
}

export function getVirementsRecusRoutePath(): string {
	return `${getSaisiesFullPath()}/${VirementsRecusRoutePath}`;
}

export function getFondsIndisponiblesRoutePath(): string {
	return `${getSaisiesFullPath()}/${FondsIndisponiblesRoutePath}`;
}

// Validation
export function getValidationRoutePath(): string {
	return `${getAuthenticatedFullPath()}/${ValidationRoutePath}`;
}

// Rapprochement Bancaire
export function getRapprochementBancaireFullPath(): string {
	return `${getAuthenticatedFullPath()}/${RapprochementBancairePath}`;
}

export function getRapprochementBancairePagePath(): string {
	return `${getRapprochementBancaireFullPath()}/${RapprochementBancairePagePath}`;
}

export function getJobIntegrationBancairePath(): string {
	return `${getRapprochementBancaireFullPath()}/${RapprochementJobIntegrationBancairePagePath}`;
}

export function getCommonSettingsLiassesChequesRoutePath(): string {
	return `${getCommonSettingsFullPath()}/${LiassesChequesRoutePath}`;
}

// Generation
export function getGenerationFullPath(): string {
	return `${getAuthenticatedFullPath()}/${GenerationPath}`;
}

export function getGenerationDesLotsPath(): string {
	return `${getGenerationFullPath()}/${GenerationConsultationPath}`;
}

export function getLotVirtuelPath(): string {
	return `${getGenerationFullPath()}/${LotVirtuelPath}`;
}

// Administration
export function getAdminFullPath(): string {
	return `${getAuthenticatedFullPath()}/${AdminRoutePath}`;
}

export function getAdminLogFullPath(): string {
	return `${getAdminFullPath()}/${AdminLogRoutePath}`;
}

export function getAdminHealthChecksFullPath(): string {
	return `${getAdminFullPath()}/${AdminHealthCheckRoutePath}`;
}

export function getAdminMaintenancePageRoutePath(): string {
	return `${getAdminFullPath()}/${MaintenancePageRoutePath}`;
}

export function getAdminFilePageRoutePath(): string {
	return `${getAdminFullPath()}/${AdminFileRoutePath}`;
}
